import { GridColDef } from "@mui/x-data-grid-pro";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiOpenProcessMenu from "src/components/core-components/mui/ByzMuiOpenProcessMenu";
import ByzMuiEditButton from "src/components/core-components/mui/buttons/ByzMuiEditButton";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";


export const useOperationAreaColumns = (): GridColDef[] => {
  const { t } = useTranslate();


  return [
    {
      field: "select",
      headerName: "",
      width: 50,
      renderCell: () => <ByzMuiCheckBox />,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
    },
    {
      field: "menu",
      headerName: "",
      width: 50,
      renderCell: () => (
        <ByzMuiOpenProcessMenu
          menuItems={[]}
          sx={{ borderBottom: '2px solid black' }}
        />
      ),
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
    },
    {
      field: "nurse",
      flex: 1,
      renderHeader: () => (
        <ByzMuiTypography isTitle>{t("safety-surgery.nurse")}</ByzMuiTypography>
      ),
    },
    {
      field: "operationName",
      flex: 1,
      renderHeader: () => (
        <ByzMuiTypography isTitle>{t("safety-surgery.operation-name")}</ByzMuiTypography>
      ),
    },
    {
      field: "operationDate",
      flex: 1,
      renderHeader: () => (
        <ByzMuiTypography isTitle>{t("date")}</ByzMuiTypography>
      ),
    },
    {
      field: "operationTime",
      flex: 1,
      renderHeader: () => (
        <ByzMuiTypography isTitle>{t("time")}</ByzMuiTypography>
      ),
    },
    {
      field: "edit",
      headerName: "",
      width: 50,
      renderCell: () => <ByzMuiEditButton />,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
    },
  ];
}